/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUniverseStructuresStructureIdPosition } from './GetUniverseStructuresStructureIdPosition';
import {
    GetUniverseStructuresStructureIdPositionFromJSON,
    GetUniverseStructuresStructureIdPositionFromJSONTyped,
    GetUniverseStructuresStructureIdPositionToJSON,
    GetUniverseStructuresStructureIdPositionToJSONTyped,
} from './GetUniverseStructuresStructureIdPosition';

/**
 * 200 ok object
 * @export
 * @interface GetUniverseStructuresStructureIdOk
 */
export interface GetUniverseStructuresStructureIdOk {
    /**
     * The full name of the structure
     * @type {string}
     * @memberof GetUniverseStructuresStructureIdOk
     */
    name: string;
    /**
     * The ID of the corporation who owns this particular structure
     * @type {number}
     * @memberof GetUniverseStructuresStructureIdOk
     */
    ownerId: number;
    /**
     * 
     * @type {GetUniverseStructuresStructureIdPosition}
     * @memberof GetUniverseStructuresStructureIdOk
     */
    position?: GetUniverseStructuresStructureIdPosition;
    /**
     * solar_system_id integer
     * @type {number}
     * @memberof GetUniverseStructuresStructureIdOk
     */
    solarSystemId: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetUniverseStructuresStructureIdOk
     */
    typeId?: number;
}

/**
 * Check if a given object implements the GetUniverseStructuresStructureIdOk interface.
 */
export function instanceOfGetUniverseStructuresStructureIdOk(value: object): value is GetUniverseStructuresStructureIdOk {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('solarSystemId' in value) || value['solarSystemId'] === undefined) return false;
    return true;
}

export function GetUniverseStructuresStructureIdOkFromJSON(json: any): GetUniverseStructuresStructureIdOk {
    return GetUniverseStructuresStructureIdOkFromJSONTyped(json, false);
}

export function GetUniverseStructuresStructureIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStructuresStructureIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ownerId': json['owner_id'],
        'position': json['position'] == null ? undefined : GetUniverseStructuresStructureIdPositionFromJSON(json['position']),
        'solarSystemId': json['solar_system_id'],
        'typeId': json['type_id'] == null ? undefined : json['type_id'],
    };
}

export function GetUniverseStructuresStructureIdOkToJSON(json: any): GetUniverseStructuresStructureIdOk {
    return GetUniverseStructuresStructureIdOkToJSONTyped(json, false);
}

export function GetUniverseStructuresStructureIdOkToJSONTyped(value?: GetUniverseStructuresStructureIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'owner_id': value['ownerId'],
        'position': GetUniverseStructuresStructureIdPositionToJSON(value['position']),
        'solar_system_id': value['solarSystemId'],
        'type_id': value['typeId'],
    };
}

